export default __webpack_public_path__ + "locales/hy-AM/DataReassignmentDialog.json?hash=8d103f90baa34bee727b35e307a1acfb";